(function () {
    'use strict';

    angular
        .module('app')
        .factory('editableFieldsService', editableFieldsService);

    editableFieldsService.$inject = ['$http', '$q', '$filter'];

    function editableFieldsService($http, $q, $filter) {
        var service = {
            notEditableFields: [],
            userFields: [],
            editableFields: [],
            getEditableFields: getEditableFields,
            setEditableFields: setEditableFields,
            processing: false,
        };

        return service;

        function getUserFields() {
            var deferred = $q.defer();

            $http.get('../Synergis.WebApi/api/column/user/').then(function (response) {
                service.userFields = response.data; //$filter('filter')(response.data, { bExtracted: true });
                deferred.resolve(service.userFields);
            });

            return deferred.promise;
        }
        function getEditableFields() {
            service.processing = true;
            var deferred = $q.defer();
            service.notEditableFields = [];
            service.editableFields = [];
            getUserFields().then(function (userFields) {
                $http.get('../Synergis.WebApi/api/column/editable/').then(function (response) {
                    angular.forEach(service.userFields, function (item) {
                        item.selected = false;
                        //var found = $filter('filter')(response.data, { fieldName: item.fieldName });
                        var found = $filter('filter')(response.data, { fieldID: item.fieldID });
                        if (found.length > 0) {
                            service.editableFields.push(item);
                        }
                        else {
                            service.notEditableFields.push(item);
                        }
                    });
                    service.processing = false;
                    deferred.resolve(response.data);
                });
            })
            return deferred.promise;
        }
        function setEditableFields(fields) {
            var deferred = $q.defer();
            service.processing = true;
            var fieldArray = [];

            angular.forEach(fields, function (field) {
                //fieldArray.push(field.fieldName);
                fieldArray.push(field.fieldID);
            });

            $http({
                url: '../Synergis.WebApi/api/column/seteditable/',
                method: 'POST',
                data: JSON.stringify(fieldArray),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.processing = false;
                deferred.resolve();
            });
            return deferred.promise;
        }
    }
})();